module.exports = __webpack_public_path__ + "img/26.43046c91.jpg";